import React from "react";
import TrophyCard from "./TrophyCard";
import LeaderRow from "./LeaderRow";
import FirstPlaceTrophy from "shared/ui/svg-icons/Leaderboard/Desktop/FirstPlace";
import SecondPlaceTrophy from "shared/ui/svg-icons/Leaderboard/Desktop/SecondPlace";
import ThirdPlaceTrophy from "shared/ui/svg-icons/Leaderboard/Desktop/ThirdPlace";

const LeaderboardDesktop = ({
  currencyCode,
  data,
  firstPlace,
  secondPlace,
  thirdPlace,
  trophyHeaders,
  headers,
  tableRows,
}) => (
  <div className="leaderboard desktop">
    <div className="sr-only" id="form-instruction">
      The following form controls will update the content in the table below.
    </div>
    <div className="leader-title">{data.title}</div>
    <div className="leader-subtitle">{data.subtitle}</div>
    <div className="leader-subtitle">{data.body}</div>
    <div className="leaderboard-content">
      <div className="cards">
        <TrophyCard
          currencyCode={currencyCode}
          data={data}
          placeData={secondPlace}
          trophyHeaders={trophyHeaders}
          Trophy={SecondPlaceTrophy}
        />

        <TrophyCard
          currencyCode={currencyCode}
          data={data}
          placeData={firstPlace}
          trophyHeaders={trophyHeaders}
          Trophy={FirstPlaceTrophy}
        />

        <TrophyCard
          currencyCode={currencyCode}
          data={data}
          placeData={thirdPlace}
          trophyHeaders={trophyHeaders}
          Trophy={ThirdPlaceTrophy}
        />
      </div>

      <div className="table-container">
        <div className="table-wrapper">
          <table className="resizeable-table">
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th key={index} className="table-header">
                    <span>{header}</span>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {tableRows.map((data, index) => (
                <LeaderRow key={index} data={data} position={index + 4} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

export default LeaderboardDesktop;
